import { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";

import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import PeopleIcon from "@material-ui/icons/People";
import ReceiptIcon from "@material-ui/icons/Receipt";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitIcon from "@material-ui/icons/ExitToApp";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { useDispatch } from "react-redux";
import { authActions, ROLES } from "../../store/auth-slice";
import { uiActions } from "../../store/ui-slice";

import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
}));

const MenuItem = (props) => {
  const location = useLocation();
  const history = useHistory();

  const clickHandler = () => {
    if (props.onClick) {
      props.onClick();
      return;
    }
    history.push(props.to);
  };

  const isSelected =
    !props.noselect && location.pathname.search(props.to) !== -1;

  return (
    <ListItem button onClick={clickHandler} selected={isSelected}>
      <ListItemIcon>{props.icon}</ListItemIcon>
      <ListItemText primary={props.itemText} />
    </ListItem>
  );
};

const MainMenu = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { role } = props;

  const handleLogout = () => {
    dispatch(authActions.logout());
    dispatch(uiActions.clearNotification());
  };

  const isMenuItemVisible = (roles, role) => {
    if (roles) {
      return roles.indexOf(role) !== -1;
    }
    return true;
  };

  const topMenuItems = [
    {
      text: "Customers",
      to: "/customers",
      icon: <PeopleIcon />,
      roles: [ROLES.ROLE_ADMINISTRATOR],
    },
    { text: "Licenses", to: "/licenses", icon: <ReceiptIcon /> },
  ].filter((item) => isMenuItemVisible(item.roles, role));

  const bottomMenuItems = [
    {
      text: "Settings",
      to: "/settings",
      icon: <SettingsIcon />,
      roles: [ROLES.ROLE_ADMINISTRATOR],
    },
    {
      text: "Exit",
      to: "/",
      icon: <ExitIcon />,
      noselect: true,
      onClick: handleLogout,
    },
  ].filter((item) => isMenuItemVisible(item.roles, role));

  return (
    <Fragment>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        {topMenuItems.map((item) => (
          <MenuItem
            key={item.text}
            itemText={item.text}
            to={item.to}
            icon={item.icon}
            onClick={item.onClick}
          />
        ))}
      </List>

      <Divider />

      <List>
        {bottomMenuItems.map((item) => (
          <MenuItem
            key={item.text}
            itemText={item.text}
            to={item.to}
            icon={item.icon}
            noselect={item.noselect}
            onClick={item.onClick}
          />
        ))}
      </List>
    </Fragment>
  );
};

export default MainMenu;
